import React from 'react';
import { motion } from 'framer-motion';

// Same partner set as /components/Partners.js — local assets work on every page
const partners = [
  { name: 'UltraTech Cement', logo: '/ultratechlogo.png' },
  { name: 'JSW Steel', logo: '/jsw.png' },
  { name: 'ACC Cement', logo: '/acc.png' },
  { name: 'Jaquar', logo: '/jaq.png' },
  { name: 'Kajaria', logo: '/kajaria.png' },
  { name: 'Schneider Electric', logo: '/Schneider.jpg' },
  { name: 'Astral', logo: '/astral.png' },
  { name: 'Ashirvad', logo: '/ashirvad.png' },
  { name: 'Cera', logo: '/cera.png' },
];

const SolidPartnersMarquee = () => {
  const track = [...partners, ...partners];
  return (
    <section className="border-t border-slate-200 bg-slate-100 py-16">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-10 text-center"
        >
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-slate-500">Our Trusted Partners</p>
        </motion.div>

        <div className="overflow-hidden">
          <motion.div
            animate={{ x: ['0%', '-50%'] }}
            transition={{ repeat: Infinity, duration: 25, ease: 'linear' }}
            className="flex w-max items-center gap-16"
          >
            {track.map((p, i) => (
              <div
                key={`${p.name}-${i}`}
                className="h-10 flex-shrink-0 opacity-80 grayscale transition-all duration-300 hover:grayscale-0 hover:opacity-100"
              >
                <img src={p.logo} alt={p.name} className="h-full w-auto object-contain" />
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default SolidPartnersMarquee;
